export const COOKIE_NAME_TOKEN = 'hubble_auth_token';
export const COOKIE_NAME_FROM_PATH = 'hubble_redirect_path';
export const COOKIE_NAME_COMPANY_NAME = 'hubble_company_name';
export const COOKIE_NAME_GOOGLE_AUTH_SOURCE = 'hubble_google_auth_source';
